import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposContasBancarias } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposContasBancarias() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_CONTAS_BANCARIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_CONTAS_BANCARIAS, rota: ROUTES.TIPOS_CONTAS_BANCARIAS, fetchData: function (busca, _filtros, paginacao) { return getTiposContasBancarias(busca, paginacao); }, columns: COLUNAS }));
}
